<template>
  <div class="pos-calculator">
    <div class="row">
      <!-- CASH INDICATOR -->
      <div class="col-11 mb-3 mx-auto">
        <div class="font-weight-bold">Cash Given</div>
        <input
          disabled
          :value="InputValue"
          type="number"
          @input="onInputChangeHandler"
          step="any"
        />
      </div>

      <div class="col-11 mb-3 mx-auto">
        <div class="font-weight-bold">Change</div>
        <input disabled :value="ChangeAmount.toFixed(2)" type="text" />
      </div>

      <div class="col-12">
        <div class="row mx-0">
          <div class="w-100">
            <div class="d-flex flex-wrap">
              <div
                v-for="(cash, cashKey) in CashList"
                :key="cashKey"
                v-on:click="onAddCashHandler($event, cash)"
                class="btn-calc-container"
              >
                <button class="btn-calc">{{ cash.denomination_value }}</button>
              </div>
              <div class="btn-calc-container">
                <button v-on:click="onAmountClear()" class="btn-calc">C</button>
              </div>
            </div>

            <div class="w-50 pl-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosService from "@/services/PosService";
export default {
  props: {
    cashdata: {
      type: Array,
      default: []
    },
    onAddMoreCash: {
      type: Function
    },
    changeAmount: {
      type: Number,
      default: 0
    },
    inputChange: {
      type: Function,
      default: () => {}
    },
    inputvalue: {
      type: String,
      default: 0
    },
    resetAmount: {
      type: Function
    }
  },
  data() {
    return {
      cashDenominations: [],
      cashRow: [],
      change: 0
    };
  },
  mounted() {},
  computed: {
    CashList() {
      return this.cashdata;
    },
    ChangeAmount() {
      return this.changeAmount;
    },
    InputValue() {
      return this.inputvalue;
    }
    //
  },
  methods: {
    onInputChangeHandler: function(event) {
      this.inputChange(event);
    },
    onAddCashHandler: function(event, Cash) {
      this.onAddMoreCash({ event, Cash });
    },
    onAmountClear: function() {
      this.resetAmount();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/PosGlobalCalculator.vue